module.exports = __webpack_public_path__ + "img/elementlengths_jasa.2cb5342b.png";